
export interface Filters {
    beginDate: string;
    endDate: string;
    storeStatus: string;
    labelFilter?: string;
    bundleLabelFilter?: string;
    entityFilter: string | null;
    status: string;
    ownerUuid: string | null;
    year: number[];
    selected: boolean;
    approvalStatus?: string;
    campaignUuid?: string;
    selectedChoice?: string|null;
}

export interface State {
    filters: SocleFilters;
}

export type SocleFilters = Filters | null;

const STORAGE_KEY = "socleFilters";

export default {
    state: {
        filters: null,
    } as State,

    mutations: {
        updateSocleFilters(state: State, filters: SocleFilters): void {
            if (!filters) {
                localStorage.removeItem(STORAGE_KEY);
                state.filters = null;
                return;
            }
            state.filters = { ...(state.filters || {}), ...filters };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state.filters));
        },
        setSocleFilters(state: State, filters: SocleFilters): void {
            if (!filters) {
                localStorage.removeItem(STORAGE_KEY);
                state.filters = null;
                return;
            }
            state.filters = { ...filters };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state.filters));
        },
    },
    getters: {
        getSocleFilters: (state: State): SocleFilters => state.filters,
    },
    actions: {
        initializeSocleFilters(
            { commit }: { commit: (mutation: string, payload: SocleFilters) => void },
            filters: SocleFilters = null
        ): void {
            try {
                const stored = localStorage.getItem(STORAGE_KEY);
                commit("setSocleFilters", stored ? JSON.parse(stored) : filters);
            } catch {
                localStorage.removeItem(STORAGE_KEY);
                commit("setSocleFilters", filters || null);
            }
        },
        resetSocleFilters(
            {commit}: { commit: (mutation: string, payload: SocleFilters) => void },
            filters: SocleFilters
        ): void {
            commit("setSocleFilters", filters);
        },
        updateSocleFilters(
            { commit }: { commit: (mutation: string, payload: SocleFilters) => void },
            filters: SocleFilters
        ): void {
            commit("updateSocleFilters", filters);
        },
    },
};
